import React from 'react';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { Col } from "react-bootstrap";

import GalleryModal from './GalleryModal';

function toWebp(src) {
    const webp = src.replace(/\.(jpg|jpeg|png)$/i, '.webp');
    return webp.replace(/ /g, '%20');
}

function GalleryItem(prop) {
    const [showFullPhoto, setShowFullPhoto] = useState(false);
    const tumbSrc = "/" + prop.tumb;
    const fullSrc = "/" + prop.photo;

    const openModal = (e) => {
        e.preventDefault();
        setShowFullPhoto(true);
    };

    return (
        <>
            <Col sm={12} md={6} lg={4}>
                <a
                    href={fullSrc}
                    className="gallery"
                    onClick={openModal}
                    aria-label={prop.alt}
                >
                    <div className="gallery-photo">
                        <picture>
                            <source srcSet={toWebp(tumbSrc)} type="image/webp" />
                            <img
                                className='img-fluid'
                                src={tumbSrc}
                                alt={prop.alt}
                                width="516"
                                height="290"
                                loading="lazy"
                                decoding="async"
                            />
                        </picture>
                    </div>
                </a>
            </Col>

            {showFullPhoto && createPortal(
                <GalleryModal
                    strings={prop.strings}
                    photo={fullSrc}
                    alt={prop.alt}
                    onClose={() => setShowFullPhoto(false)} />,
                document.body
            )}
        </>
    );
}

export default GalleryItem;
